import { ExtraView } from './model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<ExtraView> {
  isLoaded: boolean
}

export const adapter: EntityAdapter<ExtraView> = createEntityAdapter<ExtraView>({
  sortComparer: (a, b) => a.created - b.created,
  selectId: (t: ExtraView) => t.pkey,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
})
